import { ApiCarData } from '@interfaces/car-api.types';
import { FilterState } from '@interfaces/filter.types';
import { 
  ApiFilterParams, 
  transformFiltersToApiParams, 
  buildQueryString 
} from '@utils/filterTransformUtils';

export type { ApiFilterParams };

const baseURL = process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;

export const carListingService = {
  getCarList: async (offset = 0, limit = 24, cityName: string, filters?: ApiFilterParams, userId?: string): Promise<{ cars: ApiCarData[]; totalCount: number | null; pageCount?: number} | null> => {
    try {
      const page = Math.floor(offset / limit) + 1;
      const size = limit;

      const baseParams = {
        city: cityName,
        size: size.toString(),
        page: page.toString()
      };

      const queryString = filters
        ? buildQueryString(filters, baseParams)
        : buildQueryString({}, baseParams);

      const apiUrl = `${baseURL}/rest/v1/search/cars?${queryString}`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-user-id' : userId || ''
        },
      });

      const data = await response.json();
      const totalCount = data.total_count ?? null;
      const pageCount = data.total_pages;
      return { cars: data.result, totalCount, pageCount };

    } catch (error) {
      console.error('Error fetching car list:', error);
      return null;
    }
  },

  transformFilters: (filters: FilterState, filterOptions: any): ApiFilterParams => {
    return transformFiltersToApiParams(filters, filterOptions);
  }
};